import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// Removed framer-motion import to reduce main bundle size. Simple CSS-based
// transitions are used instead for the initial wrapper to avoid blocking JS.
import { useAuth } from './AuthContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import CookieConsent from './components/CookieConsent';

// Code splitting: cargar páginas bajo demanda
const HomePage = lazy(() => import('./pages/HomePage'));
const PropertiesPage = lazy(() => import('./pages/PropertiesPage'));
const ContactPage = lazy(() => import('./pages/ContactPage'));
const AddPropertyPage = lazy(() => import('./pages/AddPropertyPage'));
const LoginPage = lazy(() => import('./pages/LoginPage'));
const PropertyDetailPage = lazy(() => import('./pages/PropertyDetailPage'));
const EditPropertyPage = lazy(() => import('./pages/EditPropertyPage'));
const PrivacyPolicy = lazy(() => import('./pages/PrivacyPolicy'));
const TermsAndConditions = lazy(() => import('./pages/TermsAndConditions'));
const CookiesPolicy = lazy(() => import('./pages/CookiesPolicy'));
const Consentimiento = lazy(() => import('./pages/Consentimiento'));

const App = () => {
  const { user } = useAuth();

  return (
    <Router>
      <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex flex-col">
        <Navbar />
        <div className="pt-8 flex-grow" style={{ transition: 'opacity 0.8s' }}>
          <Suspense fallback={<div className="flex justify-center items-center py-16 text-gray-600">Cargando...</div>}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/propiedades" element={<PropertiesPage />} />
              <Route path="/propiedades/:id" element={<PropertyDetailPage />} />
              <Route path="/contacto" element={<ContactPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/privacidad" element={<PrivacyPolicy />} />
              <Route path="/terminos" element={<TermsAndConditions />} />
              <Route path="/cookies" element={<CookiesPolicy />} />
              <Route path="/consentimiento" element={<Consentimiento />} />
              {/* Ruta protegida para añadir propiedad */}
              <Route
                path="/añadir-propiedad"
                element={user ? <AddPropertyPage /> : <Navigate to="/login" replace />}
              />
              {/* Ruta protegida para editar propiedad */}
              <Route
                path="/editar-propiedad/:id"
                element={user ? <EditPropertyPage /> : <Navigate to="/login" replace />}
              />
            </Routes>
          </Suspense>
        </div>
        <Footer />
        <CookieConsent />
      </div>
    </Router>
  );
};

export default App;